import * as React from 'react';

function InfoIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9991 3.2487C7.61505 3.2487 3.25038 7.61392 3.25038 12.9987C3.25038 18.3835 7.61505 22.7487 12.9991 22.7487C18.3832 22.7487 22.7479 18.3835 22.7479 12.9987C22.7479 7.61392 18.3832 3.2487 12.9991 3.2487ZM1.08398 12.9987C1.08398 6.4173 6.41858 1.08203 12.9991 1.08203C19.5797 1.08203 24.9143 6.4173 24.9143 12.9987C24.9143 19.5801 19.5797 24.9154 12.9991 24.9154C6.41858 24.9154 1.08398 19.5801 1.08398 12.9987Z"
        fill="currentColor"
      />
      <path
        d="M12.9653 20.2148C12.0131 20.2148 11.5369 19.3491 11.5369 17.6175C11.5369 16.6785 11.2839 15.1201 11.5369 13.4218C11.79 11.7236 11.8402 11.3397 12 11C12.1065 10.7669 12.7855 10.5647 12.9653 10.5647C13.1651 10.5647 13.8935 10.7935 14 11C14.1465 11.2597 14.1833 11.7768 14.443 13.4218C14.7027 15.0668 14.4303 16.4654 14.4436 17.6175C14.4436 19.3491 13.9508 20.2148 12.9653 20.2148ZM12.9953 8.96638C12.5957 8.96638 12.2395 8.80987 11.9265 8.49686C11.6135 8.18385 11.457 7.82755 11.457 7.42796C11.457 7.02171 11.6102 6.6654 11.9165 6.35905C12.2228 6.0527 12.5824 5.89952 12.9953 5.89952C13.4148 5.89952 13.7744 6.04937 14.074 6.34906C14.3737 6.65541 14.5235 7.01505 14.5235 7.42796C14.5235 7.84087 14.3703 8.2005 14.064 8.50685C13.7577 8.8132 13.4015 8.96638 12.9953 8.96638Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoInfoIcon = React.memo(InfoIcon);
export default MemoInfoIcon;
